import {
  BASE_PATH,
  FLOW_REVISIONS_PATH,
  FLOWS_PATH,
  PROJECT_PATH,
} from '../../transport/services/config';
import { transport } from '../../transport/transport';
import { AdministrationPromise } from '../../types/administration';
import { ProjectInOrganizationId } from '../../types/entities';
import {
  CreateFlowPayload,
  Flow,
  FlowVersion,
  FlowVersionCreatePayload,
} from '../../types/flow.types';

export function getFlowsList({
  organizationId,
  project,
}: ProjectInOrganizationId): Promise<any> {
  return transport.get(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${project.id}${FLOWS_PATH}`,
  );
}

export function getFlowVersionsList(
  { organizationId, project }: ProjectInOrganizationId,
  flowId: string,
): AdministrationPromise<FlowVersion[]> {
  return transport.get(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${project.id}${FLOWS_PATH}/${flowId}${FLOW_REVISIONS_PATH}`,
  );
}

export function createFlowVersion(
  { organizationId, project }: ProjectInOrganizationId,
  flowId: string,
  version: FlowVersionCreatePayload,
): AdministrationPromise<FlowVersion> {
  return transport.post(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${project.id}${FLOWS_PATH}/${flowId}${FLOW_REVISIONS_PATH}`,
    version,
  );
}

export function createFlow(
  { organizationId, project }: ProjectInOrganizationId,
  payload: CreateFlowPayload,
): AdministrationPromise<Flow> {
  return transport.post(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${project.id}${FLOWS_PATH}`,
    payload,
  );
}

export function renameFlow(
  { organizationId, project }: ProjectInOrganizationId,
  flowId: string,
  newName: string,
): AdministrationPromise<void> {
  return transport.put(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${project.id}${FLOWS_PATH}/${flowId}`,
    { name: newName },
  );
}

export function removeFlow(
  { organizationId, project }: ProjectInOrganizationId,
  flowId: string,
): AdministrationPromise<void> {
  return transport.delete(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${project.id}${FLOWS_PATH}/${flowId}`,
  );
}

export function activateVersion(
  { organizationId, project }: ProjectInOrganizationId,
  flowId: string,
  versionRevision: number,
): AdministrationPromise<void> {
  return transport.post(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${project.id}${FLOWS_PATH}/${flowId}${FLOW_REVISIONS_PATH}/${versionRevision}/activate`,
  );
}

export function deactivateFlow(
  { organizationId, project }: ProjectInOrganizationId,
  flowId: string,
): AdministrationPromise<void> {
  return transport.post(
    `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${project.id}${FLOWS_PATH}/${flowId}/deactivate`,
  );
}
